import {
    DefaultButton,
    Dialog, DialogFooter,
    DialogType, Stack, TextField
} from "@fluentui/react";

import React from "react";

import {IStorefrontSectionCell} from "../../models/Storefront";

export interface IStorefrontSectionImagePropertyModalProps {
    cell?: IStorefrontSectionCell;
    displayModal: boolean;
    closer: () => void;
    onChangeLinkUrl?: (url: string) => void;
    onChangeAltText?: (text: string) => void;
}

const StorefrontSectionImagePropertyModal: React.FC<IStorefrontSectionImagePropertyModalProps> = props => {
    
    
    return (
        <Dialog
            hidden={!props.displayModal}
            onDismiss={props.closer}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: 'Modify Image Properties',
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            {props.cell &&
            <Stack>
                <TextField label={'Link URL'} value={props.cell.linkUrl} onChange={(e, link) => {props?.onChangeLinkUrl?.(link ?? '')}} />
                <TextField label={'Alt Text'} value={props.cell.altText} onChange={(e, altText) => {props?.onChangeAltText?.(altText ?? '')}} />
            </Stack>

            }
            <DialogFooter>
                <DefaultButton
                    primary={true}
                    text='Ok'
                    onClick={props.closer}
                />
            </DialogFooter>
        </Dialog>
    );
}
export default StorefrontSectionImagePropertyModal;